import {
  Card,
  CardBody,
  Grid,
  GridItem,
  Heading,
  Stat,
  StatLabel,
  StatNumber,
} from '@chakra-ui/react'
import { FinancialReport } from '../../../repositories/ReportRepository'

interface OwnerReportSummaryProps {
  reportData: FinancialReport
}

export function OwnerReportSummary({ reportData }: OwnerReportSummaryProps) {
  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(value)
  }

  return (
    <Card>
      <CardBody>
        <Heading size="md" mb={4}>
          Resumo do Período
        </Heading>
        <Grid
          templateColumns={{
            base: 'repeat(2, 1fr)',
            md: 'repeat(3, 1fr)',
            lg: 'repeat(8, 1fr)',
          }}
          gap={6}
        >
          <GridItem>
            <Stat>
              <StatLabel>Receita Total</StatLabel>
              <StatNumber color="green.500">
                {formatCurrency(reportData.total_revenue)}
              </StatNumber>
            </Stat>
          </GridItem>
          <GridItem>
            <Stat>
              <StatLabel>Repasses</StatLabel>
              <StatNumber color="red.500">
                {formatCurrency(
                  reportData.total_fowarding_fee + reportData.company_commission
                )}
              </StatNumber>
            </Stat>
          </GridItem>
          <GridItem>
            <Stat>
              <StatLabel>Taxa de Limpeza</StatLabel>
              <StatNumber color="red.500">
                {formatCurrency(reportData.total_cleaning_fee)}
              </StatNumber>
            </Stat>
          </GridItem>
          <GridItem>
            <Stat>
              <StatLabel>Manutenções</StatLabel>
              <StatNumber color="red.500">
                {formatCurrency(reportData.total_maintenance_fee)}
              </StatNumber>
            </Stat>
          </GridItem>
          <GridItem>
            <Stat>
              <StatLabel>Lucro</StatLabel>
              <StatNumber color="blue.500">
                {formatCurrency(
                  reportData.total_revenue -
                    (reportData.total_fowarding_fee +
                      reportData.company_commission +
                      reportData.total_cleaning_fee +
                      reportData.total_maintenance_fee)
                )}
              </StatNumber>
            </Stat>
          </GridItem>
          <GridItem>
            <Stat>
              <StatLabel>Diária Média</StatLabel>
              <StatNumber>{formatCurrency(reportData.adr)}</StatNumber>
            </Stat>
          </GridItem>
          <GridItem>
            <Stat>
              <StatLabel>Noites Vendidas</StatLabel>
              <StatNumber>{reportData.room_nights_sold}</StatNumber>
            </Stat>
          </GridItem>
          <GridItem>
            <Stat>
              <StatLabel>Taxa de Ocupação</StatLabel>
              <StatNumber>{reportData.occupancy_rate.toFixed(2)}%</StatNumber>
            </Stat>
          </GridItem>
        </Grid>
      </CardBody>
    </Card>
  )
}
